<deletemodal id="customer-tabs" [deleteModal]="deleteModal"></deletemodal>
<div class="row search-block container">
    <div *ngIf="distributorInfo" class="distributorInfo mar-top-10">
        <div *ngIf="distributorInfo.name" class="bold header-font color-black ">
            {{distributorInfo | displayNameFormat}}
        </div>
        <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="pad-b-4 bold">
            <span>{{distributorInfo.displayName | titlecase}}</span>
        </div>
        <div>
            <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
            <span *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId | distributorIdFormat}}</span>
            <span *ngIf="distributorInfo.level" class="color-black"> | {{distributorInfo.level}}</span>
        </div>
    </div>
    <!--Ticket Dashboard-->
    <div class="form-horizontal card customer-service-search-border customer-care-multiselect">

        <!-- CHANGES -->
        <!--  Ticket Number -->
        <div class="row no-margin">
            <label for="ticketNumber" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Ticket Number' | translate | translateKey}}</label>
            <div class="col-xs-3 floating-input floatLabelContainer">
                    <input #ticketType  id="ticketType" float-label tabindex="0" [(ngModel)]="ticketSearchModel.ticketNumber" class="form-control" placeholder="{{'ticketing-system.Ticket #' |translate | translateKey}}"
                    tabindex="1" type="text" (blur)="searchWithTicketNumber()" autofocus (keyup.enter)="onSearch()">
            </div>
            <div class="col-md-5">
                <!-- <span>{{ticketSearchModel.ticketNumber}}</span> -->
                <button  [disabled]="!distributorInfo" class="btn-link" tabindex="3" id="processor-btn" (click)="createTicket()" *ngIf="isTicketCreate" (keydown.Tab)="OnTabEventRecentlyViewed()">
                    <span class="glyphicon glyphicon-plus pad-r-8"></span> {{'ticketing-system.ADD NEW' | translate | translateKey}}
                </button>
            </div>
        </div>

         <!-- Country Office # -->
         <div class="row no-margin">
            <label for="teamdepartment" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Country Office' |translate}}</label>
            <div class="col-xs-3 floating-input">
                <select autofocus tabindex="0" (change)="ShowTicketAndDepatrmentBycountry($event.target.value)" id="autofocus-modal-element" class="form-control" [(ngModel)]="countryId">
                   <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
            </select>
            </div>
        </div>

        <!--  Department -->
        <div class="row  no-margin">
            <label for="teamdepartment" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Assign to Dept' | translate | translateKey}}</label>
            <div class="col-xs-3 floating-input">
                <angular2-multiselect tabindex="1"  (keyup.enter)="openDropDown('teamdepartment')"
                    id="teamdepartment" [data]="dropdownSettings.departmentDropdownList" [(ngModel)]="dropdownSettings.departmentSelectedItems"
                    [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.departmentIndex)"
                    (onDeSelect)="onItemDeSelect($event,dropdownSettings.departmentIndex)" (onSelectAll)="onSelectAll($event,dropdownSettings.departmentIndex)"
                    (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.departmentIndex)">
                </angular2-multiselect>
            </div>
           
          
            <!-- <div class="col-md-8">
                <span>Billing Department | ordersDepartment | Manufacturing cases | Finance | Products</span>
            </div> -->
            <div class="col-md-8" *ngIf="departmentOnSelectAll && dropdownSettings.departmentSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
            <div class="col-md-8" *ngIf="!departmentOnSelectAll">
                <span *ngFor="let teamdepartment of dropdownSettings.departmentSelectedItems| slice:0:8 ; let i=index">
                    {{teamdepartment.itemName}}
                    <span *ngIf="(dropdownSettings.departmentSelectedItems.length-1 > i) && !(i > 6)"> | </span>
                </span>
                <span class="addmore-link" *ngIf="dropdownSettings.departmentSelectedItems.length > 8">{{'ticketing-system.and more' |translate | translateKey}}</span>
            </div>
        </div>
        <!--  Ticket Type -->
        <div class="row  no-margin">
            <label for="ticketType" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Ticket Type' |translate | translateKey}}</label>
            <div class="col-xs-3 floating-input">
                <angular2-multiselect  (keyup.enter)="openDropDown('ticketType')" tabindex="1"
                    id="ticketType" [data]="dropdownSettings.typeDropdownList" [(ngModel)]="dropdownSettings.typeSelectedItems"
                    [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.typeIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.typeIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.typeIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.typeIndex)">
                </angular2-multiselect>
            </div>
            <!-- <div class="col-md-8">
                <span>ALL</span>
            </div> -->
            <div class="col-md-8" *ngIf="ticketTypeOnSelectAll && dropdownSettings.typeSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
            <div class="col-md-8" *ngIf="!ticketTypeOnSelectAll ">
                <span *ngFor="let ticketType of dropdownSettings.typeSelectedItems | slice:0:8 ; let i=index">{{ticketType.itemName}}
                    <span *ngIf="(dropdownSettings.typeSelectedItems.length-1 > i) && !(i > 6)"> | </span>
                </span>

                <span class="addmore-link" *ngIf="dropdownSettings.typeSelectedItems.length > 8">{{'ticketing-system.and more' | translate | translateKey}}</span>
            </div>
        </div>

        <!--  Ticket Sub Type -->
        <div class="row  no-margin">
            <label for="subType" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Ticket SubType' | translate | translateKey}}</label>
            <div class="col-xs-3 floating-input">
                <angular2-multiselect tabindex="1"  (keyup.enter)="openDropDown('subType')" id="subType"
                    [data]="dropdownSettings.subTypeDropdownList" [(ngModel)]="dropdownSettings.subTypeSelectedItems" [settings]="dropdownSettings.settings"
                    (onSelect)="onItemSelect($event,dropdownSettings.subTypeIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.subTypeIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.subTypeIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.subTypeIndex)">
                </angular2-multiselect>
            </div>
            <!-- <div class="col-md-8">
                <span>ALL</span>
            </div> -->
            <div class="col-md-8" *ngIf="!subTypeOnSelectAll">
                <span *ngFor="let subType of dropdownSettings.subTypeSelectedItems  | slice:0:8 ; let i=index">{{subType.itemName}}
                    <span *ngIf="(dropdownSettings.subTypeSelectedItems.length-1 > i) && !(i > 6)"> | </span>
                </span>

                <span class="addmore-link" *ngIf="dropdownSettings.subTypeSelectedItems.length > 8">{{'ticketing-system.and more' | translate | translateKey}}</span>
            </div>
            <div class="col-md-8" *ngIf="subTypeOnSelectAll && dropdownSettings.subTypeSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey | translateKey}}
            </div>
        </div>

        <!--  Source -->
        <div class="row  no-margin">
            <label for="source" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Source' |translate | translateKey}}</label>
            <div class="col-xs-3 floating-input">
                <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('source')" id="source"
                    [data]="dropdownSettings.sourceDropdownList" [(ngModel)]="dropdownSettings.sourceSelectedItems" [settings]="dropdownSettings.settings"
                    (onSelect)="onItemSelect($event,dropdownSettings.sourceIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.sourceIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.sourceIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.sourceIndex)">
                </angular2-multiselect>
            </div>
            <!-- <div class="col-md-8">
                <span>Web</span>
            </div> -->
            <div class="col-md-8" *ngIf="sourceOnSelectAll && dropdownSettings.sourceSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey | translateKey}}
            </div>
            <div class="col-md-8" *ngIf="!sourceOnSelectAll">
                <span *ngFor="let source of dropdownSettings.sourceSelectedItems ; let i=index">{{source.itemName}}
                    <span *ngIf="(dropdownSettings.sourceSelectedItems.length-1 > i) && !(i > 2)"> | </span>
                </span>
            </div>
        </div>

        <!--  Status -->
        <div class="row  no-margin">
            <label for="status" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Status' | translate | translateKey}}</label>
            <div class="col-xs-3 floating-input">
                <angular2-multiselect tabindex="1"  (keyup.enter)="openDropDown('status')" id="status"
                    [data]="dropdownSettings.statusDropdownList" [(ngModel)]="dropdownSettings.statusSelectedItems" [settings]="dropdownSettings.settings"
                    (onSelect)="onItemSelect($event,dropdownSettings.statusIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.statusIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.statusIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.statusIndex)">
                </angular2-multiselect>
            </div>
            <!-- <div class="col-md-8">
                <span>New | In Progress | Closed</span>
            </div> -->
            <div class="col-md-8" *ngIf="!statusOnSelectAll">
                <span *ngFor="let status of dropdownSettings.statusSelectedItems ; let i=index">{{status.itemName}}
                    <span *ngIf="(dropdownSettings.statusSelectedItems.length-1 > i) && !(i > 2)"> | </span>

                </span>
            </div>
            <div class="col-md-8" *ngIf="statusOnSelectAll && dropdownSettings.statusSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
        </div>

        <!--  Priority -->
        <div class="row  no-margin">
            <label for="source" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Priority' | translate | translateKey}}</label>
            <div class="col-xs-3 floating-input">
                <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('teampriority')"
                    id="teampriority" [data]="dropdownSettings.priorityDropdownList" [(ngModel)]="dropdownSettings.prioritySelectedItems"
                    [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.priorityIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.priorityIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.priorityIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.priorityIndex)">
                </angular2-multiselect>
            </div>
            <!-- <div class="col-md-8">
                <span>Low | Medium | High </span>
            </div> -->
            <div class="col-md-8" *ngIf="priorityOnSelectAll && dropdownSettings.prioritySelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey | translateKey}}
            </div>
            <div class="col-md-8" *ngIf="!priorityOnSelectAll">
                <span *ngFor="let teampriority of  dropdownSettings.prioritySelectedItems ; let i=index">{{teampriority.itemName}}
                    <span *ngIf="(dropdownSettings.prioritySelectedItems.length-1 > i) && !(i > 2)"> | </span>
                </span>

            </div>
        </div>
        <div class="row clearfix"></div>
        <!-- <div class="row clearfix">
            <div class="col-md-4 floating-input floatLabelContainer">
                <input autofocus float-label tabindex="0" [(ngModel)]="ticketSearchModel.ticketNumber" class="form-control" placeholder="Ticket #"
                    tabindex="0" type="text">
            </div>
            <div class="col-md-8">
                <span>USA0000001</span>
            </div>
        </div> -->

        <!-- <div class="row">
            <div class="col-md-4 floating-input">

                <angular2-multiselect tabindex="0"  (focusout)="onDropDowneBlur('teamdepartment')" (keyup.enter)="openDropDown('teamdepartment')" id="teamdepartment"
                [data]="dropdownSettings.departmentDropdownList" [(ngModel)]="dropdownSettings.departmentSelectedItems" 
                             [settings]="dropdownSettings.settings" 
                             (onSelect)="onItemSelect($event,dropdownSettings.departmentIndex)"
                             (onDeSelect)="onItemDeSelect($event,dropdownSettings.departmentIndex)" 
                             (onSelectAll)="onSelectAll($event,dropdownSettings.departmentIndex)" 
                             (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.departmentIndex)" >
             </angular2-multiselect>
            </div>
            <div class="col-md-8">
                <span>Billing Department | ordersDepartment | Manufacturing cases | Finance| Products</span>

            </div>
        </div> -->


        <!-- <div class="row">
            <div class="col-md-4 floating-input">

                <angular2-multiselect (focusout)="onDropDowneBlur('ticketType')" (keyup.enter)="openDropDown('ticketType')" tabindex="0"
                    #ticketType id="ticketType" [data]="dropdownSettings.typeDropdownList" [(ngModel)]="dropdownSettings.typeSelectedItems"
                    [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.typeIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.typeIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.typeIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.typeIndex)">
                </angular2-multiselect>
            </div>
            <div class="col-md-8">
                <span>ALL</span>
            </div>
        </div> -->

        <!-- <div class="row">
            <div class=" col-md-4 floating-input">

                <angular2-multiselect tabindex="0" (focusout)="onDropDowneBlur('subType')" (keyup.enter)="openDropDown('subType')" id="subType"
                    [data]="dropdownSettings.subTypeDropdownList" [(ngModel)]="dropdownSettings.subTypeSelectedItems" [settings]="dropdownSettings.settings"
                    (onSelect)="onItemSelect($event,dropdownSettings.subTypeIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.subTypeIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.subTypeIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.subTypeIndex)">
                </angular2-multiselect>
            </div>
            <div class="col-md-8">
                <span>ALL</span>
            </div>
        </div> -->

        <!-- <div class="row">
            <div class="col-md-4 floating-input ">               
                <angular2-multiselect tabindex="0" (focusout)="onDropDowneBlur('source')" (keyup.enter)="openDropDown('source')" id="source"
                    [data]="dropdownSettings.sourceDropdownList" [(ngModel)]="dropdownSettings.sourceSelectedItems" [settings]="dropdownSettings.settings"
                    (onSelect)="onItemSelect($event,dropdownSettings.sourceIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.sourceIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.sourceIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.sourceIndex)">
                </angular2-multiselect>
            </div>
            <div class="col-md-8">
                <span>Web</span>
            </div>

        </div> -->

        <!-- <div class="row">
            <div class="col-md-4 floating-input ">

               
                <angular2-multiselect tabindex="0" (focusout)="onDropDowneBlur('status')" (keyup.enter)="openDropDown('status')" id="status"
                    [data]="dropdownSettings.statusDropdownList" [(ngModel)]="dropdownSettings.statusSelectedItems" [settings]="dropdownSettings.settings"
                    (onSelect)="onItemSelect($event,dropdownSettings.statusIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.statusIndex)"
                    (onSelectAll)="onSelectAll($event,dropdownSettings.statusIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.statusIndex)">
                </angular2-multiselect>
            </div>
            <div class="col-md-8">
                <span>New| In Progress| Closed</span>
            </div>
        </div> -->
        <!-- <div class="row">
                <div class="col-md-4 floating-input">
        
                    <angular2-multiselect tabindex="0" (focusout)="onDropDowneBlur('teampriority')" (keyup.enter)="openDropDown('teampriority')" id="teampriority"
                    [data]="dropdownSettings.priorityDropdownList" [(ngModel)]="dropdownSettings.prioritySelectedItems" 
                                  [settings]="dropdownSettings.settings" 
                                  (onSelect)="onItemSelect($event,dropdownSettings.priorityIndex)"
                                  (onDeSelect)="onItemDeSelect($event,dropdownSettings.priorityIndex)" 
                                  (onSelectAll)="onSelectAll($event,dropdownSettings.priorityIndex)" 
                                  (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.priorityIndex)" >
                    </angular2-multiselect>
                </div>
                <div class="col-md-8">
                    <span>Low|Medium|High</span>
                </div>
        
        </div>         -->
    </div>
    <div class="pull-right button-block">
        <button class="btn blue-button" #searchbutton  id="searchbutton" tabindex="2" type="submit" (keyup.enter)="isSearchClicked = true;onSearch()" (click)="isSearchClicked = true;onSearch()">{{'ticketing-system.Search' | translate | translateKey}}</button>
        <button class="btn grey-button" tabindex="2" type="button" (click)="clearFields()">{{'ticketing-system.CLEAR' | translate | translateKey}}</button>        
    </div>

</div>
<div class="card container">  
    <div class="table-responsive pane-hScroll">
        <table class="tickets-display table table-striped custab ticket-dashbaord ticket-response">
            <thead>
                <tr>                   
                    <th class="width-25 pointer" (click)="sortTableByColumn('TICKET_NUMBER')">{{'ticketing-system.Priority' |translate | translateKey}}&nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (sortColumn  == 'TICKET_NUMBER' && !isDesc), 'fa-sort-desc': (sortColumn  == 'TICKET_NUMBER' && isDesc) }"
                            style="font-size:12px"></i>
                    </th>
                    <th class="width-30 pointer" (click)="sortTableByColumn('TICKET_NUMBER')">{{'ticketing-system.Ticket #' |translate | translateKey}}&nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (sortColumn  == 'TICKET_NUMBER' && !isDesc), 'fa-sort-desc': (sortColumn  == 'TICKET_NUMBER' && isDesc) }"
                            style="font-size:12px"></i>
                    </th>
                    <th class="width-45">{{'ticketing-system.Assigned to User' |translate}}</th>
                    <th class="width-70 pointer">{{'ticketing-system.Subject' |translate | translateKey}}</th>
                    <th class="width-35 pointer" tabindex="0" >{{'ticketing-system.Country' |translate}}</th>
                    <th class="width-55 pointer" (click)="sortTableByColumn('SUBTYPE')">{{'ticketing-system.Ticket Subtype' |translate | translateKey}} &nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'SUBTYPE', 'fa-sort-asc': (sortColumn  == 'SUBTYPE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'SUBTYPE' && isDesc) }"
                            style="font-size:10px"></i>
                    </th>
                    <th class="width-30 pointer" (click)="sortTableByColumn('STATUS')">{{'ticketing-system.Status' |translate | translateKey}}&nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'STATUS', 'fa-sort-asc': (sortColumn  == 'STATUS' && !isDesc), 'fa-sort-desc': (sortColumn  == 'STATUS' && isDesc) }"
                            style="font-size:12px"></i>
                    </th>
                    <th class="width-30 pointer" (click)="sortTableByColumn('DUE_DATE')">{{'ticketing-system.Due Date' |translate | translateKey}}&nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'DUE_DATE', 'fa-sort-asc': (sortColumn  == 'DUE_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'DUE_DATE' && isDesc) }"
                            style="font-size:12px"></i>
                    </th>
                    <th class="width-40 pointer" (click)="sortTableByColumn('CREATED_DATE')">{{'ticketing-system.Created Date' |translate | translateKey}}&nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'CREATED_DATE', 'fa-sort-asc': (sortColumn  == 'CREATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'CREATED_DATE' && isDesc) }"
                            style="font-size:12px"></i>
                    </th>
                    <th class="width-40 pointer" (click)="sortTableByColumn('UPDATED_DATE')">{{'ticketing-system.Last Modified' |translate | translateKey}}&nbsp;
                        <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'UPDATED_DATE', 'fa-sort-asc': (sortColumn  == 'UPDATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'UPDATED_DATE' && isDesc) }"
                            style="font-size:12px"></i>
                    </th>
                    <!-- <th class="width-80">{{'ticketing-system.Attachment' |translate | translateKey}}</th> -->
                    <!--<th>Assign To&nbsp;
                                        <i class="fa fa-sort" style="font-size:12px"></i>
                                    </th>-->
                    <!--<th>Spam&nbsp;</th>-->
                    <!--<th>Actions&nbsp;
                    </th>-->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ticket of myTickets | paginate: {  id: 'fbo-tickets-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">

                    <td>
                        <span class="label label-default" [class]="ticket.priorityValue.toLowerCase()">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;</td>
                    <td *ngIf="isTicketView">
                        <a (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber)" (click)="goToViewTicket(ticket.id,ticket.ticketNumber,true)">{{ticket.ticketNumber}}</a>
                    </td>
                    <td *ngIf="!isTicketView">{{ticket.ticketNumber}}</td>
                    <td>{{ticket.assignedToValue}}</td>
                    <td>{{ticket.subject}}</td>
                    <td>{{ticket.operatingCountryName}}</td>
                    <td>{{ticket.subType}}</td>
                    <td>{{ticket.status}}</td>
                    <td>{{ticket.dueDate}}</td>
                    <td>{{ticket.createdDate}}</td>
                    <td>{{ticket.modifiedDate}}</td>
                    <!-- <td>
                        <span *ngIf="ticket.attachmentExist" class="fa fa-paperclip"></span>
                    </td> -->
                </tr>
            </tbody>
            <tbody *ngIf="myTickets.length==0">
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td colspan="3" class="text-center">{{'ticketing-system.No records found' |translate | translateKey}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="absolute-position" *ngIf="myTickets.length > 0">
        <span>{{pageCount}} {{'store-user.record(s) found' |translate | translateKey}}</span>
    </div>
    <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
    <div class="pull-left margin_top-5 floating-input">
        <select tabindex="0" [(ngModel)]="pageSize" class="form-control" (change)="pageChange(1)">
            <option *ngFor="let pageSize of pageSizes" [value]="pageSize">
                {{pageSize}}</option>
        </select>
    </div>
</div>




<!--<div class="form-group" *ngIf="viewCreateTicket">
        <span class="page-heading" style="display: initial;">{{'ticketing-system.Create Ticket' |translate | translateKey}}</span>
        <i class="fa fa-arrow-circle-left pad-r-8 "></i>
        <a class="backlink pointerstyle" (click)="viewCreateTicket = false">
            {{'ticketing-system.Back to Tickets' |translate | translateKey}}</a>
    </div>
    <div *ngIf="viewCreateTicket">
        <customer-tickets-create  fboid={{fboid}}></customer-tickets-create>
    </div>-->
<!-- </div> -->


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/tickets.component.html